import { ReactElement } from "react";
import { SortedField, SortOrder } from "../../../../../shared/sort";
import styles from "./Arrow.module.scss";

interface ArrowProps
{
    field: string;
    sortedField: SortedField;
}

const Arrow = (props: ArrowProps): ReactElement | null =>
{
    const caption = props.field;
    const sortField = props.sortedField;

    if (sortField.caption !== caption)
        return <span className={styles.sortedDefault} />;

    switch (sortField.order)
    {
        case SortOrder.Asc:
            return <i className="material-icons">expand_more</i>;
        case SortOrder.Desc:
            return <i className="material-icons">expand_less</i>;
        default:
            return <span className={styles.sortedDefault} />;
    }
}

export default Arrow;